export const warningInformText = 'You are changing the list of roles available for Organisation Administrator';
export const warningInformTextBody = `We inform you that after saving the form the users will lose access
 to the information and rights which are specific for the revoked roles.`;
export const noRolesAvailableTest = 'No roles available. Please select organisation type first';
export const selectRolesText = 'Select roles to determine the list of roles available for Organisation Administrator';
